import axios from 'axios';
import {
  authPopup,
  getRefreshToken,
  logout,
  pruneSession,
} from './redux/actions/auth';
import { errorCode } from './constants';
import { configKeys, remoteConfig } from './service/firebase';
import { generateDeviceInfo } from './utils';

let isRefreshing = false;
let requestQueue = [];

const processQueue = (error, token = null) => {
  requestQueue.forEach((promise) => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });

  requestQueue = [];
};

let getInfoRequestCount = 0;
let refreshCount = 0;
let pruningCount = 0;
let alreadyOpen = false;
export default {
  setupInterceptors: (store) => {
    //add a request interceptor
    axios.interceptors.request.use((config) => {
      const { url, method } = config;
      const BASE_CONFIG_URL = remoteConfig.getValue(configKeys.userApiBaseUrl);

      const isGetInfoRequest =
        url.includes('/user/v1.1/accounts') && method === 'get';

      if (isGetInfoRequest) {
        getInfoRequestCount++;
      }

      if (isGetInfoRequest && getInfoRequestCount > 3) {
        return {
          ...config,
          cancelToken: new axios.CancelToken((cancel) =>
            cancel('Cancel repeated request')
          ),
        };
      }

      if (url.includes('/user/v1.2/sessions/refresh') && refreshCount > 1) {
        return {
          ...config,
          cancelToken: new axios.CancelToken((cancel) =>
            cancel('Cancel repeated request')
          ),
        };
      }

      if (url.includes('/user/v1.2/sessions/pruning') && pruningCount > 3) {
        return {
          ...config,
          cancelToken: new axios.CancelToken((cancel) =>
            cancel('Cancel repeated request')
          ),
        };
      }
      if (url.includes('/user')) {
        config.url = config.url.replace(
          /.+?(?=\/user)/,
          BASE_CONFIG_URL.asString()
        );
      }

      if (url.includes('/notification')) {
        // const getConfigUrl = remoteConfig.getValue(configKeys.baseURL['user']);
        // const BASE_CONFIG_URL = getConfigUrl.asString();
        config.url = config.url.replace(
          /.+?(?=\/notification)/,
          BASE_CONFIG_URL.asString()
        );
      }

      config.headers['Accept-Language'] = 'en';

      return config;
    });

    // Add a response interceptor
    axios.interceptors.response.use(
      (response) => {
        const { config, status } = response;
        const { url, method } = config;
        const isGetInfoRequest =
          url.includes('/user/v1.1/accounts') && method === 'get';
        const isValidate =
          url.includes('/user/v1.2/sessions/validateSession') &&
          method === 'post';
        //reset get info request when there has response
        if (isGetInfoRequest) {
          getInfoRequestCount = 0;
        }

        if (url.includes('/user/v1.2/sessions/refresh') && status === 200) {
          refreshCount = 0;
        }

        if (url.includes('/user/v1.2/sessions/pruning') && status === 204) {
          pruningCount = 0;
        }

        if (isValidate && status === 204) {
          alreadyOpen = false;
          console.log('refreshed open');
        }

        return response;
      },
      (err) => {
        if (!err.response) {
          throw err;
        }
        const error = err?.response?.data?.error;
        console.log('error response on network, ', error);

        if (
          error?.config &&
          (error?.code === errorCode.MODEL_UNIQUE_ERROR ||
            error?.message === 'Model UniqueConstraintError') &&
          error?.details?.fields?.uuid
        ) {
          localStorage.removeItem('device_uuid');

          const originalRequest = err.config;
          const originalPayload = JSON.parse(originalRequest.data);
          const newDeviceInfo = generateDeviceInfo();
          originalPayload.device = newDeviceInfo;
          originalRequest.data = JSON.stringify(originalPayload);

          return axios(originalRequest);
        }

        const isLogout =
          error?.config?.method === 'delete' &&
          err?.config?.url?.includes('user/v1.0/sessions');
        const isNotPartner = err?.config?.url?.includes('/ioh');

        if (
          (error?.code === errorCode.INVALID_SESSION_TOKEN ||
            error?.message === 'Session InvalidSessionToken') &&
          !isLogout &&
          !isNotPartner
        ) {
          console.log('token expired. refreshing....');
          const state = store.getState();
          const authState = state.auth;
          const { token, refreshToken } = authState;

          if (!token || !refreshToken) throw err;

          const originalRequest = err.config;
          const dispatch = store.dispatch;

          if (!originalRequest._retry) {
            //when request refresh token is process, push parallel request to queue
            if (isRefreshing) {
              return new Promise((resolve, reject) => {
                requestQueue.push({ resolve, reject });
              })
                .then((token) => {
                  // axios.defaults.headers.common['Authorization'] = token;
                  originalRequest.headers['Authorization'] = token;
                  return axios(originalRequest);
                })
                .catch((err) => {
                  console.log('error in token expire', err);
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            return new Promise((resolve, reject) => {
              dispatch(getRefreshToken())
                .then((data) => {
                  const newToken = data.data.accessToken;
                  // axios.defaults.headers.common['Authorization'] = newToken; //this appends auth header on every subsequent refreshes
                  originalRequest.headers['Authorization'] = newToken;
                  processQueue(null, newToken);
                  dispatch(pruneSession());
                  resolve(axios(originalRequest));
                  //process parallel request queue after with new token
                })
                .catch(async () => {
                  if (!alreadyOpen) {
                    await dispatch(logout());
                    dispatch(authPopup.show());
                    alreadyOpen = true;
                    return;
                  }
                })
                .finally(() => {
                  isRefreshing = false;
                });
            });
          }
        } else {
          // console.log(err);
          throw err;
        }
      }
    );
  },
};
